module.exports = __webpack_public_path__ + "img/12.80b023f9.jpg";